import React from "react";
import * as Modal from '../../common/components/modal/modalDialog';
import { createMuiTheme, MuiThemeProvider, Button, TextField } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import { blue } from "@material-ui/core/colors";
import Translate from "../../common/functions/translate";
import Snackbar from "../../common/components/snackbar/snackbar";
import { ClientDataModel } from "../../models/offerSteps/clientDataModel";

interface IProps {
    isOpen: boolean;
    toggle: any;
    selectedClient: ClientDataModel,
    onEditClientAddress: any;
}

interface IState {
    validations: Array<string>,
    selectedClient: ClientDataModel
}

const theme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            marginNormal: {
                marginTop: 5,
                marginBottom: 0,
                width: '100%'
            },
            root: {
                width: '100%'
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: '0px'
            }
        },
        MuiDialog: {
            paper: {
                margin: 0,
                maxWidth: '90% !important',
                minHeight: 300
            },
            paperFullWidth: {
                width: '40%'
            }
        },
    },
    palette: {
        primary: blue
    }
})

class EditClientAddressDialog extends React.Component<IProps, IState> {
    snackbar: any;

    constructor(props) {
        super(props);

        this.state = {
            validations: new Array<string>(),
            selectedClient: this.props.selectedClient
        }
    }

    componentDidMount() {

    }

    handleChange = (key, value) => {
        let selectedClient: ClientDataModel = { ...this.state.selectedClient };
        selectedClient[key] = value;
        this.setState({ selectedClient: { ...selectedClient } });
    }

    isValid = () => {
        let selectedClient = { ...this.state.selectedClient };
        let validations = new Array<string>(0);
        let error = "";

        if (!selectedClient.address) {
            validations.push("address");
            error += Translate("Please enter cleint address.") + " ";
        }

        this.setState({
            validations: validations
        });

        if (validations.length > 0) {
            this.snackbar.show({ severity: 'error', summary: error });
            return false;
        }

        return true;
    }

    handleSaveBtn = () => {
        if (!this.isValid()) {
            return;
        }

        let client = { ...this.state.selectedClient }
        this.props.onEditClientAddress(client);

    }

    render() {
        const { selectedClient } = this.state;

        return (
            <MuiThemeProvider theme={theme}>
                <Dialog
                    open={this.props.isOpen}
                    onClose={() => this.props.toggle(false)}
                    fullWidth
                    disableBackdropClick={true}>
                    <Modal.DialogTitle id="customized-dialog-title" onClose={() => this.props.toggle(false)}>{Translate('Edit address')}</Modal.DialogTitle>
                    <Modal.DialogContent>
                        <div>
                            <Snackbar ref={(el) => this.snackbar = el} />
                            <TextField
                                name="disctrict"
                                label={Translate("Disctrict")}
                                type="text"
                                onChange={(e) => this.handleChange('disctrict', e.target['value'])}
                                value={selectedClient.disctrict || ""}
                                style={{ width: 300, marginRight: 10, marginBottom: 10 }}
                            />
                            <TextField
                                name="municipality"
                                type="text"
                                label={Translate("Municipality")}
                                onChange={(e) => this.handleChange('municipality', e.target['value'])}
                                value={selectedClient.municipality || ""}
                                style={{ width: 300, marginRight: 10, marginBottom: 10 }}
                            />
                            <TextField
                                name="town"
                                type="text"
                                label={Translate("Town")}
                                onChange={(e) => this.handleChange('town', e.target['value'])}
                                value={selectedClient.town || ""}
                                style={{ width: 300, marginRight: 10, marginBottom: 10 }}
                            />
                            <TextField
                                name="address"
                                type="text"
                                error={this.state.validations.includes("address")}
                                label={Translate("Address")}
                                onChange={(e) => this.handleChange('address', e.target['value'])}
                                value={selectedClient.address || ""}
                                style={{ width: 300, marginRight: 10, marginBottom: 10 }}
                            />
                        </div>
                    </Modal.DialogContent>
                    <Modal.DialogActions>
                        <div>
                            <Button onClick={() => this.props.toggle(false)} variant="contained" style={{ marginRight: 10 }}>
                                {Translate("Cancel")}
                            </Button>
                            <Button color="primary"
                                variant="contained"
                                onClick={this.handleSaveBtn}>
                                {Translate('Save')}
                            </Button>
                        </div>
                    </Modal.DialogActions>
                </Dialog>
            </MuiThemeProvider>
        )
    }
}

export default EditClientAddressDialog